import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IPlandaySettings } from '@fi-app/external-platform-integration/planday/planday';
import { ILightWeightArea, ILightWeightObject } from '@fi-shared/models';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'planday-settings',
    templateUrl: './planday-settings.component.html',
    styleUrls: ['./planday-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'planday-settings' },
    standalone: false,
})
export class PlandaySettingsComponent implements OnInit {
    @Input() plandaySettings: IPlandaySettings;
    @Input() areas: ILightWeightArea[];
    @Input() businessAreas: ILightWeightObject[];

    constructor(
        private plandayService: PlandayService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiCustomerDataService: FiCustomerDataService,
    ) {}

    ngOnInit(): void {
        this.saveChangesWarningService.start(() => this.plandaySettings);
    }

    getCustomerDisplayName(): string {
        return this.fiCustomerDataService.customerData.DisplayName;
    }

    savePlandaySettings() {
        this.saveChangesWarningService.stop();
        this.plandayService.savePlandaySettings(this.plandaySettings).then(() => {
            this.saveChangesWarningService.start(() => this.plandaySettings);
        });
    }
}
